// removed by extract-text-webpack-plugin
module.exports = {"icon":"mobileNavIcons__icon__a4365a2c","favorite":"mobileNavIcons__favorite__a4365a2c","container":"mobileNavIcons__container__a4365a2c","count":"mobileNavIcons__count__a4365a2c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavIcons/mobileNavIcons.scss
// module id = ./src/components/MobileNav/MobileNavIcons/mobileNavIcons.scss
// module chunks = 4